import { render, staticRenderFns } from "./LogObjectives.vue?vue&type=template&id=3ab656be"
import script from "./LogObjectives.vue?vue&type=script&lang=js"
export * from "./LogObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports